export default __webpack_public_path__ + "static/media/about-mobile.d3a0f4fc.png";